module.exports = __webpack_public_path__ + "static/media/logo_black.e3799283.png";